import { useHistory } from 'react-router-dom';
import { User } from '../../../../@types';
import { canAccessIpaPriceOptimization, IPA_PRO_HOME_PATH } from '../../../../utils/ipaAccess';

export interface CheckUserAllowAccessProps {
  usuario: User | null;
}

export function useCheckUserAllowAccess({ usuario }: CheckUserAllowAccessProps) {
  const history = useHistory();

  if (!usuario || !usuario?.codigoCliente) {
    return null;
  }

  if (!canAccessIpaPriceOptimization(usuario)) {
    history.push(IPA_PRO_HOME_PATH);
    return null;
  }
}
